<template>
  <div>
    <div class="cuadro">
      <img v-if="tipo === 'asiento' && disponible === 1 && seleccionado === false && pantalla === false" src="/img/venta/disponible.png" class="centrado" @click="selectAsiento()" v-on:click.right.prevent="blockAsiento()" style="cursor: pointer;">
      <img v-if="tipo === 'asiento' && disponible === 1 && seleccionado === false && pantalla === true" src="/img/venta/asientotv.png" class="centrado" @click="selectAsiento()" v-on:click.right.prevent="blockAsiento()" style="cursor: pointer;">
      <img v-if="tipo === 'asiento' && disponible === 0 && seleccionado === true" src="/img/venta/seleccionado.png" class="centrado">
      <img v-if="tipo === 'asiento' && disponible === 0 && seleccionado === false && ocupado === 1" src="/img/venta/proceso.png" class="centrado">
      <img v-if="tipo === 'asiento' && disponible === 0 && seleccionado === false && ocupado === 4" src="/img/venta/bloqueado.png" class="centrado" v-on:click.right.prevent="blockAsiento()" style="cursor: pointer;">
      <img v-if="tipo === 'asiento' && disponible === 0 && seleccionado === false && ocupado != 1 && ocupado != 4" src="/img/venta/ocupado.png" class="centrado">
      <div class="text-center">
        <span class="numeroAsiento" v-if="numero && disponible === 0 && seleccionado === false && ocupado != '4'">{{numero}}|{{categoria_letra}}</span>
        <span class="numeroAsiento" v-if="numero && disponible === 1 && seleccionado === false" @click="selectAsiento()" v-on:click.right.prevent="blockAsiento()" style="cursor: pointer;">{{numero}}|{{categoria_letra}}</span>
        <span class="numeroAsiento" v-if="numero && disponible === 0 && seleccionado === false && ocupado === '4'" v-on:click.right.prevent="blockAsiento()" style="cursor: pointer;">{{numero}}|{{categoria_letra}}</span>
        <span class="numeroAsiento" v-if="numero && seleccionado === true" style="color: white;">{{numero}}|{{categoria_letra}}</span>
      </div>
      <!--<span class="pantallaAsiento" v-if="pantalla === true">TV</span>-->

      <img v-if="banoTipo === 'Mixto'" src="/img/layout/mixto.png" class="centrado">
      <img v-if="banoTipo === 'Hombres'" src="/img/layout/hombres.png" class="centrado">
      <img v-if="banoTipo === 'Mujeres'" src="/img/layout/mujeres.png" class="centrado">

      <img v-if="tipo === 'escalera'" src="/img/layout/escalera.png" class="centrado">
      <img v-if="tipo === 'operador'" src="/img/layout/operador.png" class="centrado">
      <img v-if="tipo === 'television'" src="/img/layout/television.png" class="centrado">
      <img v-if="tipo === 'cafeteria'" src="/img/layout/cafeteria.png" class="centrado">
    </div>
    <!-- MODAL AUTORIZA BLOQUEO ASIENTO -->
      <modal :show.sync="showBloqueoAsientoModal" :hasParent="true" modal-classes="modal-primary" size="sm">
        <h6 v-if="ocupado != '4'" slot="header" class="mb-0 modal-title">Autorizar bloqueo de asiento</h6>
        <h6 v-else slot="header" class="mb-0 modal-title">Autorizar desbloqueo de asiento</h6>
        <form class="new-event--form" @submit.prevent="authBlockAsiento">
          <base-input label="Token"
                      placeholder="Ingrese token"
                      v-model="auth.token"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.token"/>
          <!--
          <base-input label="Usuario"
                      placeholder="Ingrese usuario"
                      v-model="auth.usuario"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.usuario" />
          <base-input label="Contraseña"
                      placeholder="Ingrese contraseña"
                      v-model="auth.password"
                      type="password"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.password"/>
          <validation-error :errors="apiValidationErrors.permiso"/>
          -->
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
  
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="authBlockAsiento">Autorizar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showBloqueoAsientoModal = false">Cerrar</button>
        </template>
      </modal>
      <!-- MODAL MOTIVO BLOQUEO ASIENTO -->
      <modal :show.sync="showMotiveModal" :hasParent="true" modal-classes="modal-primary" size="sm">
        <h6 slot="header" class="mb-0 modal-title">Bloqueo de asiento #<span v-if="value">{{value.numero}}</span></h6>
        <form class="new-event--form" @submit.prevent="motiveBlockAsiento">
          <base-input label="Motivo de bloqueo"
                      placeholder="Ingrese motivo"
                      v-model="motive.motivo"
                      input-classes="form-control-alternative new-event--title">
          </base-input>
          <validation-error :errors="apiValidationErrors.motivo" />
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="motiveBlockAsiento">Confirmar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showMotiveModal = false">Cerrar</button>
        </template>
      </modal>

      <modal :show.sync="showDesbloquearModal" :hasParent="true" modal-classes="modal-primary" size="sm">
        <h6 slot="header" class="mb-0 modal-title">Desbloqueo de asiento #<span v-if="value">{{value.numero}}</span></h6>
        <form class="new-event--form" @submit.prevent="desbloquearAsiento">
          <span v-if="value">Esta por desbloquear el asiento, el motivo de bloqueo fue: <span v-if="value.motivo_bloqueo === ''">{{ motive.motivo }}</span> <span v-else>{{value.motivo_bloqueo}}</span> </span>
          <input type="hidden" class="new-event--start"/>
          <input type="hidden" class="new-event--end"/>
        </form>
        <template slot="footer">
          <button type="submit" class="btn btn-default hover-apolo new-event--add" @click="desbloquearAsiento">Confirmar</button>
          <button type="button" class="btn btn-primary hover-apolo ml-auto" @click="showDesbloquearModal = false">Cerrar</button>
        </template>
      </modal>
  </div>
  
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import ValidationError from "@/components/ValidationError.vue";
import { Modal } from "@/components/";

export default {
  components: {
    Modal, ValidationError
  },
  mixins: [formMixin],
  props: {
    value: { required: false },
    canjearBoleto: { required: false },
    addDetail: { required: false },
    token_id: { required: false },
    id: { required: false },
    payment_details: { required: false },
    showPayCanjeTicketModal: {required: true}
  },
  data() {
    return {
      auth: {
        type: "autorizar",
        token: null
      },
      autorizacionBloqueo: false,
      showBloqueoAsientoModal: false,
      showMotiveModal: false,
      showDesbloquearModal: false,
      motive: {},
      permiso: {},
      seleccion: {},
      tipo: null,
      disponible: null,
      seleccionado: false,
      ocupado: '',
      motivo_ocupado: '',
      motivo_ocupado: '',
      numero: null,
      categoria: null,
      categoria_letra: null,
      pantalla: false,
      precio_taquilla: null,
      precio_en_linea: null,
      motivo_bloqueo: null,
      bano: null,
      banoTipo: null,
      banos: [
        { nombre: 'Mixto'},
        { nombre: 'Hombres'},
        { nombre: 'Mujeres'}
      ],
    };
  },
  created() {
    if(!!this.value){
      if(this.value.tipo){
        this.tipo = this.value.tipo;
      }
      if(this.value.tipo === 'asiento'){
        this.disponible = this.value.disponible;
        this.numero = this.value.numero;
        const categoriaNombre = this.value.categoria.nombre;
        this.categoria_letra = categoriaNombre.charAt(0);
        this.categoria = this.value.categoria;
        this.pantalla = this.value.pantalla;
        this.ocupado = Number(this.value.motivo_ocupado);
        this.motivo_bloqueo = this.value.motivo_bloqueo;
        this.motivo_ocupado = Number(this.value.motivo_ocupado);
        this.precio_taquilla = this.value.precio_taquilla;
        this.precio_en_linea = this.value.precio_en_linea;
      }
      this.banoTipo = this.value.bano;
      if(this.value.bano === 'Mixto'){
        this.bano = this.banos[0];
      }
      if(this.value.bano === 'Hombres'){
        this.bano = this.banos[1];
      }
      if(this.value.bano === 'Mujeres'){
        this.bano = this.banos[2];
      }
    }
  },
  mounted(){
    window.Echo.channel(`Token.${this.canjearBoleto.token_id}`).listen('TokenVentaEvent',(data)=>{  
      if(data.status === 'inactive' && this.showPayCanjeTicketModal === false){
        this.$router.go(this.$router.currentRoute)
      }
    })
    if(this.canjearBoleto.subcorrida_id != null){
      window.Echo.channel(`Subcorrida.${this.canjearBoleto.subcorrida_id}`).listen('AsientoInteractivoEvent',(asiento)=>{  
        if(Number(this.numero) === Number(asiento.asiento.asiento)){
          this.disponible = asiento.asiento.disponible;
          this.ocupado = asiento.asiento.motivo_ocupado;
          this.updateItem();
        }
      })
    }
  },
  computed: {
  },
  methods: {
    updateItem(){
      const val = {
        'disponible': this.disponible, 
        'ocupado': this.ocupado, 
        'seleccionado': this.seleccionado, 
        'numero': this.numero, 
        'categoria': this.categoria, 
        'categoria_letra': this.categoria_letra, 
        'tipo': this.tipo,
        'motivo_bloqueo': this.motivo_bloqueo,
        'motivo_ocupado': this.motivo_ocupado,
        'precio_en_linea': this.precio_en_linea,
        'precio_taquilla': this.precio_taquilla,
        'id': this.id,
      };
      this.$emit('input', val);
    },

    async resetAsiento(){
      this.seleccion.tipo = 'deseleccion';
      this.seleccion.numero_asiento = this.value.numero;
      this.seleccion.token_id = this.token_id;
      this.seleccion.corrida_id = this.canjearBoleto.corrida_id;
      this.seleccion.subcorrida_id = this.canjearBoleto.subcorrida_id;
      this.seleccion.canal = 1;
      try {
        await this.$store.dispatch("ventas/seleccionar", this.seleccion);
        this.value.id = this.id;
        this.disponible = 1;
        this.seleccionado = false;
        this.updateItem();
      }catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
        //this.resetApiValidation();
        //this.setApiValidation(error.response.data.errors);
      }
    },

    async selectAsiento(){
      if(this.payment_details.length === 1){
        this.$notify({
          type: "danger",
          message: "Solo es posible canjear un boleto",
          duration: -1
        });
        return;
      }
      this.seleccion.tipo = 'seleccion';
      this.seleccion.numero_asiento = this.value.numero;
      this.seleccion.token_id = this.token_id;
      this.seleccion.corrida_id = this.canjearBoleto.corrida_id;
      this.seleccion.subcorrida_id = this.canjearBoleto.subcorrida_id;
      this.seleccion.canal = 1;
      try {
        await this.$store.dispatch("ventas/seleccionar", this.seleccion);
        this.seleccionado = true;
        this.disponible = 0;
        this.value.id = this.id;
        this.updateItem();
        this.addDetail(this.value);
      }catch (error) {
        if (error.response.data.errors[0]) {
            this.$notify({
                type: "danger",
                message: error.response.data.errors[0].detail,
                duration: -1
            });
        } else {
            this.$notify({
                type: "danger",
                message: "Oops, ha ocurrido un problema!",
                duration: -1
            });
        }
        //this.resetApiValidation();
        //this.setApiValidation(error.response.data.errors);
      }
    },

    async desbloquearAsiento(){
      this.motive.token = this.auth.token;
      this.motive.tipo = 'desbloqueo'
      this.motive.motivo = 'desbloquear asiento';
      this.motive.corrida_id = this.canjearBoleto.corrida_id;
      this.motive.subcorrida_id = this.canjearBoleto.subcorrida_id;
      try {
        await this.$store.dispatch("ventas/bloquear", this.motive);
        this.disponible = 1;
        this.seleccionado = false;
        this.ocupado = '';
        this.motivo_bloqueo = '';
        this.updateItem();
        this.$notify({
          type: "success",
          message: "Asiento desbloqueado satisfactoriamente.",
          duration: -1
        });
        this.motive.motivo = '';
        this.showDesbloquearModal = false;
        } catch (error) {
          if(error.response.data.message != undefined){
            this.$notify({
                type: "danger",
                message: error.response.data.message,
                duration: -1
            });
          }else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },

    async motiveBlockAsiento(){
      this.motive.tipo = 'bloqueo'
      this.motive.corrida_id = this.canjearBoleto.corrida_id;
      this.motive.subcorrida_id = this.canjearBoleto.subcorrida_id;
      this.motive.token = this.auth.token;
      try {
        await this.$store.dispatch("ventas/bloquear", this.motive);
        this.disponible = 0;
        this.seleccionado = false;
        this.ocupado = 4;
        this.motivo_bloqueo = this.motive.motivo;
        this.updateItem();
        this.$notify({
          type: "success",
          message: "Asiento bloqueado satisfactoriamente.",
          duration: -1
        });
        this.showMotiveModal = false;
        } catch (error) {
          if(error.response.data.message != undefined){
            this.$notify({
                type: "danger",
                message: error.response.data.message,
                duration: -1
            });
          }else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    
    //PASO 2 DE BLOQUEO
    async authBlockAsiento(){
      //this.auth.permiso = 'view autorizar bloqueo asiento';
      try {
        await this.$store.dispatch("ventas/autorizacionToken", this.auth).then(() => {
          this.motive.token = this.$store.getters["ventas/autorizacionToken"];
          this.motive.token = this.motive.token.result.token;
        });
        this.showBloqueoAsientoModal = false;
        if(this.ocupado === 4){
          this.showDesbloquearModal = true;
        }else{
          this.showMotiveModal = true;
        }
        } catch (error) {
          if (error.response.data.errors[0]) {
              this.$notify({
                  type: "danger",
                  message: error.response.data.errors[0].detail,
                  duration: -1
              });
          } else {
              this.$notify({
                  type: "danger",
                  message: "Oops, ha ocurrido un problema!",
                  duration: -1
              });
          }
          this.resetApiValidation();
          this.setApiValidation(error.response.data.errors);
        }
    },
    //PASO 1 DE BLOQUEO
    async blockAsiento(){
      this.permiso.permiso = 'view autorizar bloqueo asiento';
      this.motive.numero_asiento = this.value.numero;
      this.motive.token_id = this.token_id;
      try {
        await this.$store.dispatch("ventas/verificacion", this.permiso);
        this.motive.bloqueo_autorizado_por = null;
        if(this.ocupado === 4){
          this.showDesbloquearModal = true;
        }else{
          this.showMotiveModal = true;
        }
      }catch (error) {
        this.showBloqueoAsientoModal = true;
        //this.resetApiValidation();
        //this.setApiValidation(error.response.data.errors);
      }
    },
  },
  watch: {
    value(newValue) {
      if(!!newValue){
        //this.tipo = newValue.tipo;
      } 
    },
  },
};
</script>
<style>
    .cuadro{
      background-color:#fff !important;
      border-style: none !important;
      border-color: #989295 !important;
      height: 65px;
      width: 65px;
    }
    .cuadro:hover{
      background-color: #fff !important;
      cursor: auto;
    }
    .centrado{
      position: relative;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 55px;
      width: 55px;
    }
    .numeroAsiento{
      position:relative;
      bottom: 35px !important;
      font-size: 11px !important;
      right: -3px !important;
    }
    .pantallaAsiento{
      position:relative;
      bottom: 88px !important;
      left: 0px;
      font-size: 10px !important;
    }
</style>
<style lang="scss">
    .argon-error {
      position: relative;
      bottom: 25px !important;
      color: #fb6340;
      }
  
</style>

